/* unplugin-vue-components disabled */import { render } from "./Layout.vue?vue&type=template&id=450cc557&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=450cc557&scoped=true&lang=css"
import "./Layout.vue?vue&type=style&index=1&id=450cc557&lang=css"

import exportComponent from "/home/runner/work/gh-docs-frontend/gh-docs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450cc557"]])

export default __exports__